"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deliveryCountries = void 0;
exports.deliveryCountries = [
    {
        countryCode: 'AT',
        countryId: 1,
        countryIso: '040',
        countryTranslations: {
            EN: {
                countryDescription: 'Austria',
                languageCode: 'EN',
                languageId: 3,
            },
        },
    },
];
//# sourceMappingURL=DeliveryCountryTypes.js.map